define(["jquery", "eventManager", "bootstrap", "site/TEKsystems.SitecoreXP.Common"], function ($, eventManager, bootstrap, Common) {

	var searchQuery = "";
	var searchFilterNames = ["solution", "service", "industry", "ctype"];
    var solrFilterMapping = {"solution": "solution_sm", "service": "service_sm", "industry": "industry_sm", "ctype":"contenttype2_sm" };
	var searchFilters = { solution: [], service: [], industry: [], ctype: [] };

	function GenerateUrlQuery(query, filters) {
		return "?q=" + query + filterUrlParameters(filters);
	} 

	function UpdateUrl(query, filters) {
		var path = window.location.origin + window.location.pathname;
		var url = path + GenerateUrlQuery(query, filters);
		window.history.pushState({ url: url, query: query, filters: filters }, "", url);
	}

	function filterUrlParameters(filters) {
		var param = "";

		for (i = 0; i < searchFilterNames.length; i++) {
			var filterName = searchFilterNames[i];

			if (filters[filterName].length > 0) {
				param = param + "&" + filterName + "=" + concatenateFilterArray(filters[filterName]);
			}
		}

		return param;
	}

	function concatenateFilterArray(filterArray) {
		var output = "";
		for (var i = 0; i < filterArray.length; i++) {
			if (output.length > 0) {
				output = output + ",";
			}

			output = output + filterArray[i];
		}

		return output;
	}

	function splitFilterString(filterString) {
		var values = filterString.split(",");

		if (values.length > 0) {
			if (values[0].length > 0) {
				return values;
			}
		}

		return [];
	}

	function getSearchQuery() {
		searchQuery = Common.URL.GetParameterByName("q");
		return searchQuery;
	}

	function getFilters() {
		for (i = 0; i < searchFilterNames.length; i++) {
			var filterName = searchFilterNames[i];
			searchFilters[filterName] = splitFilterString(Common.URL.GetParameterByName(filterName));
		}
		return searchFilters;
	}

	function getSolrMapping(filterName) {
        return solrFilterMapping[filterName];
	}

	function updateSearch() {
		var query = searchQuery;
		var filters = searchFilters;

		UpdateUrl(query, filters);
		eventManager.trigger("search:update", query, filters);
	}

	function setupMobileFilterPanel() {
		$(document).on("click", function (event) {
			if ($(".score-accordion-panel .panel-heading").is(":visible")) { // Accordion panel shown on mobile only
				if ($(".score-accordion-panel .panel-collapse").hasClass("in")) { // If the accordion panel is opened
					$(".score-accordion-panel .panel-heading a").addClass("collapsed");
					$(".score-accordion-panel .panel-heading a").attr("aria-expanded", false);
					$(".score-accordion-panel .panel-collapse").removeClass("in");
					$(".score-accordion-panel .panel-collapse").attr("aria-expanded", false);
				}
			}
		});
	}

	function SearchFilter() {

        getSearchQuery();

        getFilters();

		setupMobileFilterPanel();

		this.GetUrlQuery = function() {
			return GenerateUrlQuery(searchQuery, searchFilters);
		}

		this.UpdateSearch = function () {
	        updateSearch();
	    }

		this.search = function search(query) {
			searchQuery = query;
			updateSearch();
		}

		this.addFilter = function (filterName, value) {
			if (filterName && filterName.length > 0) {
				var name = filterName.toLowerCase();
				var v = searchFilters[name];
				var i = v.indexOf(value);
				if (i === -1) {
					v.push(value);
				}
				searchFilters[name] = v;
				updateSearch();
			}
		}

		this.filter = function filter(filterName, value) {
			if (filterName && filterName.length > 0) {
				var name = filterName.toLowerCase();
				var v = searchFilters[name];
				var i = v.indexOf(value);
				if (i === -1) {
				    v.push(value);
				} else {
					v.splice(i, 1);
				}
				searchFilters[name] = v;
				updateSearch();
			}
		}

		this.remove = function remove(filterName, value) {
			if (filterName && filterName.length > 0) {
				var name = filterName.toLowerCase();
				var v = searchFilters[name];
				var i = v.indexOf(value.toString());
				if (i != -1) {
				    v.splice(i, 1);
				}
				searchFilters[name] = v;
				updateSearch();
			}
		}
		this.clearAll = function clearAll()
		{
            searchFilters = { solution: [], service: [], industry: [], ctype: [] };
		    updateSearch();
        }

		this.searchAndFilter = function searchAndFilter(query, filter, value) {
			searchQuery = query;
			this.filter(filter, value);
		};

		this.AddParamToUrl = function (url, name, value) {
			if (value == null || value.length == 0) {
				return url;
			}

			if (url[url.length - 1] != "?") {
				url = url + "&";
			}

			return url + name + "=" + value;
		}

		this.GetSearchQuery = function () {
			return getSearchQuery();
		}

		this.GetFilters = function () {
			return getFilters();
		}

		this.GetFilterNames = function() {
			return searchFilterNames;
		}

		this.SearchCompleted = function (values) {

		    eventManager.trigger("search:completed", values);
		}

		this.GetFilterValues = function (filterName, filterValues) {

		    if (filterValues == null) { return []; }
		    return $.grep(filterValues, function (e) { return e.Name == solrFilterMapping[filterName]; })[0];
		}

        this.SetupBrowserHistoryRefresh = function () {
            window.onpopstate = function (event)
            {
            	$('input:text').val("");
            	var query = null;
            	var filters = null;
            	if (event.state != undefined && event.state) {
            		query = event.state.query;
            		filters = event.state.filters;
            	}

            	eventManager.trigger("search:update", query, filters);
            }
        }
	}

	return new SearchFilter();
});